import React from 'react';
import { connect } from 'react-redux';
import {DeleteDialog} from 'modules/dialog';
import {Input, DropDownTreeSelectOneElement} from 'components/tt-forms/common';
import {validatable} from 'components/utils';
import { DuLieuHeThong } from 'api';

class RowItemCoQuanTiepDan extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getCoQuanTiepDan.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'coQuanTiepDanList',
            data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  onChange(name, e) {
    let newData = {
      coQuanToChucTiepDanId: this.props.item.coQuanToChucTiepDanId,
      ten: this.props.item.ten,
      nguoiDaiDien: this.props.item.nguoiDaiDien,
      chucVu: this.props.item.chucVu
    }
    newData[name] = e.target.value || '';
    this.props.onChange(newData, this.props.count - 1);
  }

  handleRemove() {
    this.props.onRemove(this.props.count - 1);
  }

  render() {
    return (
      <tr>
        <td style={{width: 45, minWidth: 45, maxWidth: 45, padding: 10}}>{this.props.count}</td>
        <td style={{width: 300, minWidth: 300, maxWidth: 250, padding: 10}}>
          <DropDownTreeSelectOneElement className='col-100 mb0-18' bindValidator={this} channel="formTaoDon" placeholder require dataOptions={this.state.data} value={this.props.item.ten} onChange={this.onChange.bind(this, 'ten')} propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId'/>
        </td>
        <td style={{ minWidth: 200, padding: 10}}>
          <Input className="col-100 mb0-18" value={this.props.item.nguoiDaiDien} onChange={this.onChange.bind(this, 'nguoiDaiDien')}/>
        </td>
        <td style={{ minWidth: 200, padding: 10}}>
          <Input className="col-100 mb0-18" value={this.props.item.chucVu} onChange={this.onChange.bind(this, 'chucVu')}/>
        </td>
        <td style={{minWidth: 110, textAlign: 'left'}}>
          <div className="todo-wrap">
            <DeleteDialog
              title= {'Xác nhận'}
              content= {'Bạn chắc chắn muốn xoá cơ quan này?'}
              onSuccess={this.handleRemove.bind(this)}
            />
          </div>
        </td>
      </tr>
    );
  }
}

RowItemCoQuanTiepDan.defaultProps = {
  item: {
    ten: '',
    nguoiDaiDien: '',
    chucVu: ''
  },
  data: []
}

function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.coQuanTiepDanList
  };
}

export default connect(bindStateToProps)(validatable(RowItemCoQuanTiepDan));



// WEBPACK FOOTER //
// ./src/components/modules/reception/datatable/add/RowItemCoQuanTiepDan.jsx